import './Footer.css'

const Footer = () => {
  const year = new Date().getFullYear()
  
  return (
    <footer>
      <div className="container">
        <p>&copy; {year} ITCPR. All rights reserved.</p>
      </div>
    </footer>
  )
}

export default Footer

